export default __webpack_public_path__ + "static/media/GPALogo.b35c435f.png";